import type { AssetDefinition } from './types';

const shadow = { shape: 'ellipse' as const, opacity: 0.28, scale: 0.8, offsetX: 0.08, offsetY: 0.05 };

export const BUILTIN_ASSETS: AssetDefinition[] = [
  ['builtin-tree', 'Ancient tree', 'vegetation', { width: 1, height: 1 }, 'tall'],
  ['builtin-house', 'Timber house', 'building', { width: 2, height: 2 }, 'tall'],
  ['builtin-well', 'Village well', 'prop', { width: 1, height: 1 }, 'small'],
  ['builtin-tower', 'Watch tower', 'building', { width: 2, height: 2 }, 'landmark'],
  ['builtin-character', 'Wanderer', 'character', { width: 1, height: 1 }, 'small'],
  ['builtin-horse', 'Horse', 'creature', { width: 1, height: 1 }, 'medium'],
].map(([uuid, name, type, footprint, heightClass]) => ({
  uuid: uuid as string,
  version: 1,
  slug: uuid as string,
  name: name as string,
  type: type as AssetDefinition['type'],
  tags: ['starter'],
  url: '',
  footprint: footprint as AssetDefinition['footprint'],
  pivot: { x: 0.5, y: 0.92 },
  sortAnchor: 0.92,
  walkable: false,
  highlightable: true,
  heightClass: heightClass as AssetDefinition['heightClass'],
  shadow,
  animations: {},
}));

